export const contactDataCreationObject = (data) => {
  let objectTemp = {
    first_name: data.first_name,
    last_name: data.last_name,
    contact_charge_id: data.contact_charge_id,
    contact_id: data?.contact_id,
    jurisdiction_id: data?.jurisdiction_id || null,
    politic_space_id: data?.politic_space_id || null,
    district_id: data?.district_id || null,
    area_id: data?.area_id || null,
    block_id: data?.block_id || null,
    profile_url: data?.profile_url,
    charge_end_at: data?.charge_end_at,
    charge_start_at: data?.charge_start_at,
    contact_id: data?.contact_id,
    facebook_url: data?.facebook_url,
    linkedin_url: data?.linkedin_url,
    instagram_url: data?.instagram_url,
    website_url: data?.website_url,
    instagram_username: data?.instagram_username,
    twitter_url: data?.twitter_url,
    twitter_username: data?.twitter_username,
    contact_id: data?.contact_id,
    whatsapp_1: data?.whatsapp_1,
    email_1: data?.email_1,
    whatsapp_2: data?.whatsapp_2,
    email_2: data?.email_2,
    whatsapp_3: data?.whatsapp_3,
    email_3: data?.email_3,
    entities: data?.entities,
    asesors: data?.asesors,
    comissions: data?.comissions || null,
  };

  return objectTemp;
};

export const getAllContactDataUpdateObject = (data) => {
  let objectTemp = {
    first_name: data.first_name,
    last_name: data.last_name,
    contact_charge_id: data.contact_charge_id,
    contact_id: data?.contact_id,
    jurisdiction_id: data?.jurisdiction_id || null,
    politic_space_id: data?.politic_space_id || null,
    district_id: data?.district_id || null,
    area_id: data?.area_id || null,
    block_id: data?.block_id || null,
    profile_url: data?.profile_url,
    charge_end_at: data?.charge_end_at,
    charge_start_at: data?.charge_start_at,
    contact_id: data?.contact_id,
    facebook_url: data?.facebook_url,
    linkedin_url: data?.linkedin_url,
    instagram_url: data?.instagram_url,
    website_url: data?.website_url,
    instagram_username: data?.instagram_username,
    twitter_url: data?.twitter_url,
    twitter_username: data?.twitter_username,
    contact_id: data?.contact_id,
    whatsapp_1: data?.whatsapp_1,
    email_1: data?.email_1,
    whatsapp_2: data?.whatsapp_2,
    email_2: data?.email_2,
    whatsapp_3: data?.whatsapp_3,
    email_3: data?.email_3,
    entities: data?.entities,
    asesors: data?.asesors,
    comissions: data?.comissions || null,
  };

  return objectTemp;
};
export const getContactCreationObject = (data) => {
  let objectTemp = {
    first_name: data.first_name,
    last_name: data.last_name,
    contact_charge_id: data.contact_charge_id,
  };

  return objectTemp;
};

export const getContactUpdatenObject = (data) => {
  let objectTemp = {
    first_name: data.first_name,
    last_name: data.last_name,
    contact_charge_id: data.contact_charge_id,
  };

  return objectTemp;
};

export const contactPersonalDataCreationObject = (data) => {
  let objectTemp = {
    contact_id: data?.contact_id,
    jurisdiction_id: data?.jurisdiction_id || null,
    politic_space_id: data?.politic_space_id || null,
    district_id: data?.district_id || null,
    block_id: data?.block_id || null,
    profile_url: data?.profile_url,
    charge_end_at: data?.charge_end_at,
    charge_start_at: data?.charge_start_at,
    comission_id: data?.comission_id || null,
  };

  return objectTemp;
};

export const getContactPersonalDataUpdateObject = (data) => {
  let objectTemp = {
    jurisdiction_id: data?.jurisdiction_id || null,
    politic_space_id: data?.politic_space_id || null,
    district_id: data?.district_id || null,
    block_id: data?.block_id || null,
    profile_url: data?.profile_url,
    charge_end_at: data?.charge_end_at,
    charge_start_at: data?.charge_start_at,
    comission_id: data?.comission_id || null,
  };

  return objectTemp;
};

export const contactSocialDataCreationObject = (data) => {
  let objectTemp = {
    contact_id: data?.contact_id,
    facebook_url: data?.facebook_url,
    linkedin_url: data?.linkedin_url,
    instagram_url: data?.instagram_url,
    website_url: data?.website_url,
    instagram_username: data?.instagram_username,
    twitter_url: data?.twitter_url,
    twitter_username: data?.twitter_username,
  };

  return objectTemp;
};

export const getContactSocialDataUpdateObject = (data) => {
  let objectTemp = {
    facebook_url: data?.facebook_url,
    linkedin_url: data?.linkedin_url,
    instagram_url: data?.instagram_url,
    website_url: data?.website_url,
    instagram_username: data?.instagram_username,
    twitter_url: data?.twitter_url,
    twitter_username: data?.twitter_username,
  };

  return objectTemp;
};

export const contactComunicationDataCreationObject = (data) => {
  let objectTemp = {
    contact_id: data?.contact_id,
    whatsapp_1: data?.whatsapp_1,
    email_1: data?.email_1,
    whatsapp_2: data?.whatsapp_2,
    email_2: data?.email_2,
    whatsapp_3: data?.whatsapp_3,
    email_3: data?.email_3,
  };

  return objectTemp;
};

export const getContactComunicationDataUpdateObject = (data) => {
  let objectTemp = {
    contact_id: data?.contact_id,
    whatsapp_1: data?.whatsapp_1,
    email_1: data?.email_1,
    whatsapp_2: data?.whatsapp_2,
    email_2: data?.email_2,
    whatsapp_3: data?.whatsapp_3,
    email_3: data?.email_3,
  };

  return objectTemp;
};

export const getContacEntitiesUpdateObject = (data) => {
  let objectTemp = {
    entities: data,
  };

  return objectTemp;
};
